import { Sound } from '@/enums/Audio'

export default {
  data() {
    return {
      audioContext: null,
      sound: null,
      isSoundSupported: true
    }
  },

  computed: {
    bellSound() {
      return require('@/assets/sound/message.mp3')
    }
  },

  created() {
    this.initSound()
  },

  beforeDestroy() {
    this.cleanupSound()
  },

  methods: {
    initSound() {
      try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext

        if (!AudioContextClass) {
          this.isSoundSupported = false
          return
        }

        this.audioContext = new AudioContextClass()
        this.sound = new Sound(this.audioContext)
      } catch (e) {
        console.error('Web Audio API is not supported', e)
        this.isSoundSupported = false
      }
    },

    playBeep(frequency = 800, duration = 1.2) {
      if (!this.sound || !this.isSoundSupported) return

      // Если аудиоконтекст в suspended состоянии
      if (this.audioContext?.state === 'suspended') {
        this.audioContext.resume().then(() => {
          this.sound.play(frequency, duration)
        })
      } else {
        this.sound.play(frequency, duration)
      }
    },

    async playBellSound() {
      try {
        const sound = await fetch(this.bellSound)
        const buffer = await sound.arrayBuffer()
        const audio = new (window.AudioContext || window.webkitAudioContext)()
        const source = audio.createBufferSource()
        source.buffer = await audio.decodeAudioData(buffer)
        source.connect(audio.destination)
        source.start()
      } catch (error) {
        console.error('Error playing bell sound:', error)
      }
    },

    cleanupSound() {
      if (this.audioContext) {
        this.audioContext.close()
      }
    }
  }
}
